export function isMobileUA() {
	return document.documentElement.classList.contains(`ua-mobile`);
}